/**
 * HowToPlay — shared "how to play" popup for solo and multiplayer.
 */

export default function HowToPlay({ onClose, variant = 'solo' }) {
  return (
    <div className="how-overlay" onClick={onClose}>
      <div className="how-popup" onClick={e => e.stopPropagation()}>
        <button className="how-close" onClick={onClose} aria-label="Close">{'\u00d7'}</button>
        <h2 className="how-title">How to Play</h2>
        <div className="how-body">
          <p>Click any word to explore its <strong>semantic neighbors</strong>.</p>
          <p>Each click reveals related words that branch outward through meaning-space.</p>
          {variant === 'solo' ? (
            <>
              <p>Your goal: reach the <span className="how-target">target word</span> in as few moves as possible.</p>
              <p>Words closer in meaning appear closer on the graph. Use the connections to navigate toward your target.</p>
            </>
          ) : (
            <>
              <p>Your goal: reach the <span className="how-target">target word</span> before the other players!</p>
              <p>All players act simultaneously. After each expand or combine, you enter a <strong>3-second cooldown</strong> before you can act again.</p>
            </>
          )}
          <p><strong>Combine</strong>: drag one word onto another to discover the word between them in meaning-space.</p>
          {variant === 'multiplayer' && (
            <p><strong>Bomb</strong>: each player has 2 bombs. Use one to destroy a node and all nodes directly connected to it. Great for blocking opponents!</p>
          )}
        </div>
        <div className="how-legend">
          <div className="how-legend-row"><span className="legend-swatch start" /><span>Start word</span></div>
          <div className="how-legend-row"><span className="legend-swatch expanded" /><span>Explored</span></div>
          <div className="how-legend-row"><span className="legend-swatch fresh" /><span>Newly discovered</span></div>
          <div className="how-legend-row"><span className="legend-swatch target" /><span>Target word</span></div>
        </div>
      </div>
    </div>
  );
}
